import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

export function useLoadCarrier(loadCarrierId: string) {
	/** Query */
	const query = useQuery({
		queryKey: ["load-carrier", loadCarrierId],
		queryFn: async () => {
			const response = await client.stock["load-carriers"][":loadCarrierId"].$get({
				param: { loadCarrierId },
			});
			const data = await responseHandler(response);
			return data.loadCarrier;
		},
	});

	/** Return */
	return { ...query, loadCarrier: query.data };
}
